module.exports = __webpack_public_path__ + "img/img1.3e972c14.jpg";